// extracted by mini-css-extract-plugin
module.exports = {"v1wfe94i":"v1wfe94i"};